import React, { useEffect, useRef, useState } from "react";
import api from "../services/api";
import searchIcon from "../assets/images/search_icon.svg";
import addIcon from "../assets/images/add-icon.svg";
import arrowIcon from "../assets/images/Arrow.svg";
import editIcon from "../assets/images/edit_icon.svg";
import deleteIcon from "../assets/images/icons/delete_icon.svg";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../styles/dataTable.css";
import "../styles/manageCategory.css";

const ManageMetaTags = () => {
  const [metaTags, setMetaTags] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const navigate = useNavigate();

  const fetchMetaTags = async () => {
    try {
      const { data } = await api.get("/metatag/get-all");
      if (data.status === "success") setMetaTags(data.data);
    } catch (error) {
      console.error("Failed to load meta tags", error);
    }
  };

  useEffect(() => {
    fetchMetaTags();
  }, []);

  const filteredData = metaTags.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  if (sortField) {
    filteredData.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];

      return typeof valA === "number"
        ? sortOrder === "asc"
          ? valA - valB
          : valB - valA
        : sortOrder === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });
  }

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [search, entriesPerPage, totalPages]);

  const handleSort = (field) => {
    if (sortField === field)
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const handleEdit = (row) => {
    navigate(`/manage-metatags/edit/${row.id}`);
  };


  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this MetaTag?")) return;

    try {
        const res = await api.get(`/metatag/delete/${id}`);

        if (res.data.status === "success") {
        toast.success("MetaTag deleted successfully");
        setMetaTags(metaTags.filter((item) => item.id !== id));
        } else {
        toast.error("Failed to delete MetaTag");
        }
    } catch (error) {
        console.error("Error deleting meta tag:", error);
        toast.error("Error deleting meta tag");
    }
    };


  return (
    <div style={{ position: "relative" , height: 'auto', overflow: 'hidden'}}>
      {/* Blur background when popup open */}
      <div
        style={{
          padding: "20px",
          opacity: 1,
          pointerEvents: "auto",
        }}
      >
        <div className="table-header">
          <h2 style={{ fontWeight: 700 }}>Manage MetaTags</h2>

          <div className="search-container">
            <input
              type="text"
              value={search}
              placeholder="search"
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
            <img src={searchIcon} className="search-icon" alt="search-icon" />
          </div>

          <div className="entries-container">
            <label>Show: </label>
            <select
              value={entriesPerPage}
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
            >
              <option value={10}>10 Entries</option>
              <option value={50}>50 Entries</option>
              <option value={100}>100 Entries</option>
            </select>
          </div>

          <div className="action-btn">
            <button
              onClick={() => navigate("/manage-metatags/create")}
            >
              <img src={addIcon} alt="add-icon" /> Add Metatag
            </button>
          </div>
        </div>

        {/* Table */}
        <table width="100%" cellPadding="26" className="table-no-outer-border">
          <thead>
            <tr>
              <th>Sr.</th>
              <th onClick={() => handleSort("meta_url")}>URL</th>
              <th onClick={() => handleSort("meta_title")}>Title</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.length ? (
              paginatedData.map((row, i) => (
                <tr key={row.id}>
                  <td>{(currentPage - 1) * entriesPerPage + i + 1}</td>
                  <td>{row.meta_url}</td>
                  <td>{row.meta_title}</td>

                  <td>

                    <div className="buttons-actions">
                        <button className="edit-button" onClick={() => handleEdit(row)}>
                        <img src={editIcon} alt="edit" /> Edit
                        </button>

                        <button
                            className="delete-button"
                            onClick={() => handleDelete(row.id)}
                        
                        >
                            <img src={deleteIcon} alt="delete" />
                        </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} style={{ textAlign: "center" }}>
                  No data
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div style={{ padding: "30px", textAlign: "center" }}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
          >
            <img src={arrowIcon} alt="arrow-icon" />
          </button>

          {Array.from({ length: totalPages }, (_, k) => (
            <button
              key={k + 1}
              style={{
                background: currentPage === k + 1 ? "#D9D9D9" : "#fff",
              }}
              onClick={() => setCurrentPage(k + 1)}
            >
              {k + 1}
            </button>
          ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
          >
            <img style={{ transform: "rotateY(180deg)" }} src={arrowIcon} alt="arrow-icon" />
          </button>
        </div>
      </div>

    </div>
  );
};

export default ManageMetaTags;
